<article class="card" id="admin" *ngIf="user == undefined">
  <header class="card-title" *ngIf="title !== undefined">{{title}}</header>
  <p class="header-loading">Carregando...</p>
  <div class="spin-position">
    <div class="spin-animation-admin"></div>
  </div>
</article>

<article id="user" *ngIf="user == true">
  <header class="card-title" *ngIf="title !== undefined">{{title}}</header>
  <p class="header-loading">Carregando...</p>
  <div class="spin-position">
    <div class="spin-animation-user"></div>
  </div>
</article>